export const BLOCK_TABLE_CONTROL_BASE_CLASS =
  "flex w-full flex-col gap-3 p-4 border-v2-border-default bg-neutral-default"

export const BLOCK_TABLE_CONTROL_EXTENDED_CLASS =
  "rounded-t-surface border-l border-r border-t mt-4"
